import React, { useState } from "react";
import { Button, Input, Popover, Space } from "antd";
import { Editor } from "slate";
import KoIcon from '@kwapio/icons';
import styles from "../../editor.module.scss";
import KoButton from "packages/button";

export const LinkButton = ({editor, disabled}) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");

  const insertLink = (url) => {
    if (!url) return;
    Editor.addMark(editor, "link", true);
    Editor.addMark(editor, "url", url);
    setOpen(false);
    setUrl("");
  };

  const removeLink = () => {
    Editor.removeMark(editor, "link");
    Editor.removeMark(editor, "url");
    setOpen(false);
    setUrl("");
  };

  const handleOpenChange = (visible) => {
    if (visible) {
      const marks = Editor.marks(editor);
      if (marks && marks.link && marks.url) {
        setUrl(marks.url); // ✅ Prefill existing link
      } else {
        setUrl(""); // Otherwise clear
      }
    }
    setOpen(visible);
  };

  const content = (
    <Space direction="vertical" style={{ minWidth: "30rem" }}>
      <Input
        placeholder="Enter URL"
        value={url}
        className={styles.inputLink}
        onChange={(e) => setUrl(e.target.value)}
        onPressEnter={() => insertLink(url)}
      />
      <div className={styles.buttonWrapper}>
        <Button type="primary" onClick={() => insertLink(url)}>
          Add Link
        </Button>
        {url&& <Button danger onClick={removeLink}>
          Unlink
        </Button>}
      </div>
    </Space>
  );

  return (
    <Popover
      content={content}
      title="Insert Link"
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange} // ✅ Use handler now
    >
      <KoButton
        type="text"
        iconBtn
        disabled={disabled}
        active={open}
        icon={<KoIcon width={20} height={20} name="LinkOutlined" />} />
    </Popover>
  );
};
